module.exports = __webpack_public_path__ + "static/img/zip.3bc59758.png";